
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

interface SummaryItem {
    dealerName: string;
    itemName: string;
    totalCurrentMonth: number;
    totalPreviousMonth: number;
    totalCurrentMonthLastYear: number;
}

interface DealerSummary {
    name: string;
    items: SummaryItem[];
}

@Component({
    model: {
        prop: 'show',
        event: 'update:show'
    }
})
export default class SummaryDailySales extends Vue {
    @Prop({ default: false }) show!: boolean;
    @Prop({ type: Array, default: () => [] }) readonly dealersData!: DealerSummary[];
    @Prop({ type: String, default: '' }) readonly currentMonth!: string;
    @Prop({ type: String, default: '' }) readonly previousMonth!: string;
    @Prop({ type: Number, default: new Date().getFullYear() }) readonly year!: number;

    dialog: boolean = false;

    @Watch('show', { immediate: true })
    onShowChanged(val: boolean) {
        this.dialog = val;
    }

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (!val) {
            this.$emit('update:show', false);
        }
    }

    get summaryTitle(): string {
        return 'Resumen de Ventas Diarias';
    }

    get loadingSummary(): boolean {
        return false;
    }

    get summaryHeaders() {
        return [
            { text: 'Dealer', value: 'dealerName' },
            { text: 'Items', value: 'itemName' },
            { text: `Total ${this.currentMonth}`, value: 'totalCurrentMonth' },
            { text: `Total ${this.previousMonth}`, value: 'totalPreviousMonth' },
            { text: `Total ${this.currentMonth} ${this.year - 1}`, value: 'totalCurrentMonthLastYear' }
        ];
    }

    get summaryItems() {
        if (!this.dealersData) return [];
        const rows: SummaryItem[] = [];
        this.dealersData.forEach(dealer => {
            if (!dealer.items) return;
            dealer.items.forEach(item => {
                rows.push({
                    dealerName: dealer.name,
                    itemName: (item as any).name,
                    totalCurrentMonth: item.totalCurrentMonth,
                    totalPreviousMonth: item.totalPreviousMonth,
                    totalCurrentMonthLastYear: item.totalCurrentMonthLastYear
                });
            });
        });
        return rows;
    }

    shouldShowDealerName(dealerName: string, index: number): boolean {
        if (index === 0) return true;
        const prevItem = this.summaryItems[index - 1];
        return prevItem.dealerName !== dealerName;
    }

    closeDialog() {
        this.dialog = false;
    }
}
